export const searchBarStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 2,
  },

  searchField: {
    minWidth: '300px',
    '& .MuiOutlinedInput-root': {
      height: '40px',
      '& .MuiOutlinedInput-input': {
        padding: '8px 12px',
      },
    },
  },

  searchIcon: {
    color: 'text.secondary',
  },
};
